<template>
  <div class="card">
    <div class="card-body">
      <h2 v-if="$userIsGraduate">{{ placement.agency ? placement.agency.name : 'Agency undefined' }}</h2>
      <h2 v-else>
        <router-link
          :to="{ name: 'graduates.single', params: { id: graduate.id } }"
        >{{ graduate.name }}</router-link>
      </h2>

      <template v-if="$userIsManager">
        <p>
          <strong>Current Placement</strong>
          <br>{{ currentPlacementAgency }}
        </p>

        <p>
          <strong>Home Agency</strong>
          <br>{{ homeAgency }}
        </p>
      </template>

      <div class="row">
        <div class="col-6 col-lg-3">
          <p>
            <strong>Start Date</strong>
            <br>
            {{ placement.start_date | date }}
          </p>
        </div>
        <div class="col-6 col-lg-3">
          <p>
            <strong>End Date</strong>
            <br>
            {{ placement.end_date | date }}
          </p>
        </div>
        <div class="col-12 col-lg-6" v-if="$userIsAdmin || $userIsCoordinator">
          <p>
            <strong>Agency</strong>
            <br>
            {{ placement.agency ? placement.agency.name : 'Unassigned' }}
          </p>
        </div>
      </div>
      <!-- /.row -->

      <div class="row" v-if="$userIsGraduate || $userIsManager">
        <div class="col-6 col-lg-3">
          <p>
            <strong>Region</strong>
            <br>
            {{ placement.region | nullable }}
          </p>
        </div>
        <div class="col-12 col-lg-6">
          <p class="text-truncate">
            <strong>Placement Email</strong>
            <br>
            {{ placement.email | nullable }}
          </p>
        </div>
      </div>
      <!-- /.row -->

      <p class="mb-0" v-if="!$userIsAdmin && !$userIsGraduate && !$userIsManager">
        <strong>Graduate</strong>
        <br>
        <span class="mr-4">{{ graduate.name }}</span>
        <a :href="`mailto:${graduate.email}`" class="mr-4 text-muted">{{ graduate.email }}</a>
        <a
          v-if="graduate.phone"
          :href="`tel:${graduate.phone}`"
          class="text-muted"
        >{{ graduate.phone }}</a>
      </p>

      <div v-if="!$userIsManager" class="row mt-3">
        <div class="col d-flex align-items-center">
          <p class="mb-0">
            <strong>Assigned Manager</strong>
            <br>
            <span
              class="mr-4"
            >{{ placement.manager ? placement.manager.name : 'Manager undefined' }}</span>
            <a
              v-if="placement.manager"
              :href="`mailto:${placement.manager.email}`"
              class="mr-4 text-muted"
            >{{ placement.manager.email }}</a>
            <a
              v-if="placement.manager && placement.manager.phone"
              :href="`tel:${placement.manager.phone}`"
              class="text-muted"
            >{{ placement.manager.phone }}</a>
          </p>
        </div>

        <div class="col-auto d-flex align-items-center" v-if="($userIsAdmin || placementHasACoordinatorsAgency) && placementIsNotFinalised">
          <button
            type="button"
            class="btn btn-sm btn-outline-info"
            data-toggle="modal"
            data-target=".modal-change-manager">
            <font-awesome :icon="['far', 'retweet-alt']"/> Change manager
          </button>
        </div>
      </div>
      <!-- /.row -->
    </div>

    <portal to="modals">
      <change-manager-modal @selected="updatePlacementManager"/>
      <create-manager-drawer :agency-default="placement.agency" @created="managerWasCreated"/>
    </portal>
  </div>
  <!-- /.card -->
</template>

<script>
import { graduateComputed, programGraduateMethods, placementComputed, placementMethods, agencyComputed, agencyMethods } from 'vx/helpers'
import { helpers as placementHelpers } from 'mixins/placements'
import { helpers as graduateHelpers } from 'mixins/graduates'
import ChangeManagerModal from './ChangeManagerModal'
import CreateManagerDrawer from 'components/CreateManagerDrawer'

export default {
  mixins: [placementHelpers, graduateHelpers],

  computed: {
    ...graduateComputed,
    ...placementComputed,
    ...agencyComputed
  },

  components: {
    ChangeManagerModal,
    CreateManagerDrawer
  },

  created () {
    this.getAgencies()
  },

  methods: {
    ...agencyMethods,
    ...placementMethods,
    ...programGraduateMethods,

    /**
     * When new manager is created, if it's agency_id is the same as this
     * placement's then we will update the manager on the placement to this new
     * one
     */
    async managerWasCreated (manager) {
      if (manager.agency_id === this.placement.agency_id) {
        await this.updateManagerAssignment({
          manager,
          program: this.graduate.program.id,
          graduate: this.graduate,
          placement: this.placement
        })

        this.updatePlacementManager(manager)
      }
    },

    updatePlacementManager (manager) {
      this.setPlacementProperty({ property: 'manager', value: manager })
      this.setPlacementProperty({ property: 'manager_id', value: manager.id })
    }
  }
}
</script>
